export default __webpack_public_path__ + "static/media/96@2x-8.08b1fcc3.png";